export default __webpack_public_path__ + "mpi_logo.png";